import { useSseQuery, type UseSseQueryResult } from './useSseQuery';
import type { FlowStreamEvent } from '../lib/types';

export function useClusterFlow(
  slug: string | null
): UseSseQueryResult<FlowStreamEvent> {
  const enabled = !!slug && slug !== 'all';
  return useSseQuery<FlowStreamEvent>({
    kind: 'flow',
    cluster: enabled ? (slug as string) : undefined,
    enabled,
  });
}
